module.exports = __webpack_public_path__ + "static/media/mens_journal_logo.f8d980bc.svg";